import FormPasswordReset from '@/components/FormPasswordReset'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: FormPasswordReset,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}